import { createItemToggleHandler } from './common'

document
	.querySelectorAll<HTMLElement>('section.simpleAccordion')
	.forEach(accordion => {
		accordion.querySelectorAll<HTMLElement>('.accordion-item').forEach(item => {
			const heading = item.querySelector('h5')
			heading?.addEventListener('click', createItemToggleHandler(item))
		})
	})
